import React from 'react';
import './Preloader.scss';
import clsx from 'clsx';

export interface IPreloaderProps {
    className?: string;
    classNameLabel?: string;
    size?: 's' | 's2' | 'm' | 'l' | 'xl';
    variant?: 'default' | 'white' | 'inherit';
    position?: 'default' | 'inline' | 'static';
    label?: string;
}

const Preloader: React.FC<IPreloaderProps> = ({
    className = '',
    size = 'm',
    variant = 'default',
    position = 'default',
    label,
    classNameLabel = '',
}: IPreloaderProps) => (
    <div
        className={clsx(
            'preloader',
            `preloader--position-${position}`,
            `preloader--${size}`,
            `preloader--${variant}`,
            className,
        )}
    >
        <div className={clsx(`preloader__spinner`)}>
            <svg className="preloader__circle" viewBox="0 0 50 50">
                <circle className="preloader__path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
            </svg>
        </div>
        {label && <div className={clsx('preloader__label', classNameLabel)}>{label}</div>}
    </div>
);

export default Preloader;
